import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class PopupService {
  Receive_info: Subject<any> = new Subject();
  constructor(public httpClient: HttpClient) { }

  // async GetLocation() {
  //   return await this.api.getLocation();    
  // }

  
  Show(data){
    this.Receive_info.next({  data:data});
   }
 
   close(data){
     this.Receive_info.next(data);
    }
  

}
